module.exports = __webpack_public_path__ + "static/assets/063adc84a67766e1cd17c71317acf3f5.svg";